(() => {
  if (window.SlabHubLiveGallery) return;
  window.SlabHubLiveGallery = true;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const observers = new WeakMap();
  const dialogs = new WeakMap();
  function bind(gallery) {
    if (gallery.dataset.shBound) return;
    gallery.dataset.shBound = 'true';
    if ('IntersectionObserver' in window && !reduced.matches) {
      const observer = new IntersectionObserver(entries => entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('sh-live-reveal');
          observer.unobserve(entry.target);
        }
      }), {threshold: .12});
      gallery.querySelectorAll('.sh-live-photo').forEach(photo => observer.observe(photo));
      observers.set(gallery, observer);
    }
    if (!gallery.hasAttribute('data-product-gallery')) return;
    const photos = [...gallery.querySelectorAll('[data-sh-photo]')];
    const dialog = document.createElement('dialog');
    dialog.className = 'sh-live-dialog';
    dialog.setAttribute('aria-label', gallery.dataset.dialog);
    const stage = document.createElement('div');
    stage.className = 'sh-live-dialog__stage';
    const image = document.createElement('img');
    image.draggable = false;
    stage.append(image);
    function button(className, label, glyph, action) {
      const element = document.createElement('button');
      element.type = 'button'; element.className = className;
      element.setAttribute('aria-label', label); element.textContent = glyph;
      element.addEventListener('click', action); return element;
    }
    let index = 0, trigger, previousOverflow, start, moved = false;
    const close = button('sh-live-dialog__close', gallery.dataset.close, '×', () => dialog.close());
    const previous = button('sh-live-dialog__prev', gallery.dataset.previous, '‹', () => show(index - 1));
    const next = button('sh-live-dialog__next', gallery.dataset.next, '›', () => show(index + 1));
    previous.hidden = next.hidden = photos.length < 2;
    const counter = document.createElement('div');
    counter.className = 'sh-live-dialog__counter';
    counter.setAttribute('role', 'status'); counter.setAttribute('aria-live', 'polite');
    dialog.append(stage, close, previous, next, counter);
    gallery.append(dialog); dialogs.set(gallery, dialog);
    function show(value) {
      index = (value + photos.length) % photos.length;
      image.alt = photos[index].querySelector('img').alt;
      image.src = photos[index].href;
      counter.textContent = `${index + 1} / ${photos.length}`;
    }
    photos.forEach((photo, photoIndex) => photo.addEventListener('click', event => {
      if (!dialog.showModal || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      event.preventDefault(); trigger = photo; show(photoIndex);
      previousOverflow = document.documentElement.style.overflow;
      dialog.showModal(); document.documentElement.style.overflow = 'hidden'; close.focus();
    }));
    dialog.addEventListener('close', () => {
      document.documentElement.style.overflow = previousOverflow || '';
      if (trigger?.isConnected) trigger.focus({preventScroll: true});
      start = null;
    });
    dialog.addEventListener('keydown', event => {
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault(); show(index + (event.key === 'ArrowLeft' ? -1 : 1));
      }
    });
    stage.addEventListener('pointerdown', event => {moved = false; start = {x: event.clientX, y: event.clientY};});
    stage.addEventListener('pointerup', event => {
      if (!start) return;
      const dx = event.clientX - start.x, dy = event.clientY - start.y;
      moved = Math.abs(dx) > 10 || Math.abs(dy) > 10;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.3) show(index + (dx < 0 ? 1 : -1));
      start = null;
    });
    stage.addEventListener('pointercancel', () => {start = null;});
    stage.addEventListener('click', event => {if (event.target === stage && !moved) dialog.close();});
  }
  function boot() {document.querySelectorAll('[data-sh-live-gallery]').forEach(bind);}
  boot(); document.addEventListener('DOMContentLoaded', boot, {once: true});
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-sh-live-gallery]').forEach(gallery => {
      observers.get(gallery)?.disconnect();
      const dialog = dialogs.get(gallery); if (dialog?.open) dialog.close();
    });
  });
})();
